export default "__VITE_ASSET__CaX7nLVO__"